<template>
  <popup ref="popup" :loading="popupLoading" :appendToBody="true">
    <div slot="body" class="tab-body">
      <div class="dataTable autoFlex" v-if="listData">
        <el-table
          class="table"
          :data="listData"
          align="center"
          :header-cell-style="{ 'text-align': 'center' }"
          height="auto"
          v-loading="listLoading"
        >
          <el-table-column width="45px" prop="name" label="No">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column width="110px" prop="cptdate" label="日期">
          </el-table-column>
          <el-table-column width="400px" prop="cptname" label="收支名称">
           <template slot-scope="scope">
              <el-input
                placeholder="同金额不可以同名"
                v-model="scope.row.cptname"
                autocomplete="off"
              ></el-input>
          </template>
          </el-table-column>
          <el-table-column width="110px" prop="cptacount" label="金额">
             <template slot-scope="scope">
                <el-input
                v-model="scope.row.cptacount"
                autocomplete="off"
              ></el-input>
                 </template>
          </el-table-column>
          <el-table-column width="160px" prop="ctype" label="业务类型">
            <template slot-scope="scope">
                <el-input
                v-model="scope.row.ctype"
                autocomplete="off"
              ></el-input>
                 </template>
          </el-table-column>
               <el-table-column width="110px" prop="ctype" label="类型确认">
                 <template slot-scope="scope">
                   <select-option-dictionary v-model="scope.row.ctype" dkey="cw-type" :multiple="false"
								:stringMode="true"></select-option-dictionary> 
                 </template>
          </el-table-column>
          <el-table-column width="110px"  prop="cpttpname"  label="账户" ></el-table-column>
           
        </el-table>
  <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span style="color:red;-">{{titleErr}}</span>
  </div>

</el-card>
      </div>
      <div slot="footer">
        <el-button @click="upload" type="success">{{ title }}</el-button>
        <el-button @click="close" type="danger">取消</el-button>
      </div>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/cw/cwcapitals.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";

export default {
  name: "uploadlist",
  components: {
    popup,
    selectOptionDictionary
  },
  data() {
    return {
      popupLoading: false,
      confirmLoading: false,
      listData: [],
      listLoading: false,
      title: "",
      income:0,
      outcome:0,
      titleErr:""
    };
  },
  methods: {
    //打开弹框
    open(parameter, title) { 
      this.fname = parameter;
      this.title = title;
      this.income =0;
      this.outcome=0;

      this.listLoading = true;
      this.$refs.popup.open(title, "75%");

      this.$nextTick(() => {
        api.toPush({ fname : this.fname }, (response) => {
  
          this.listData = response.data;

          if(this.listData && this.listData.length>0){
               this.listData.forEach(v=>{
                 if( v.cptacount>0 ){
                   this.income+=v.cptacount
                 }else{
                    this.outcome+=v.cptacount
                 }
               })
          }
        
           this.titleErr ="   成功解析【 "+this.listData.length+" 】条, 收入【 "+  this.income.toFixed(2) +" 】元，支出【 "+ this.outcome.toFixed(2) +" 】元。"
         
          this.listLoading = false;

        });
      });
    }, close() { //关闭弹框
          this.$refs.popup.close();
    }, upload(){

      api.importData(  this.listData  , ( res ) => {
            this.$alert("操作完毕",  res.msg, {  confirmButtonText: "确定"  });
            this.$refs.popup.close();
            this.$emit("flush");
            this.listLoading = false;

          }, ( err ) => {
            this.$alert(msg,  "导入失败，请联系管理员。", {  confirmButtonText: "确定"  });
            this.listLoading = false;
        });

    }
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
